<template>
  <div class="event-types-view mt-3">
    <div
      v-for="(each, index) in event_types"
      :key="index"
      class="event-type mb-2 me-2"
    >
      <div
        class="box"
        :style="`background:${each.background};border:${each.border}`"
      ></div>
      <div class="text">
        {{ each.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["event_types"],
};
</script>

<style lang="scss" scoped>
.event-types-view {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .event-type {
    display: flex;
    align-items: center;

    .box {
      border-radius: 0.375rem;
      height: 22px;
      width: 22px;
      margin-inline-end: 0.25rem;
    }

    .text {
      color: var(--color-17);
      font-weight: 400;
      font-size: 12px;
    }
  }
}
</style>
